import { useHistory } from 'react-router';
import * as React from 'react';

import { History } from 'history';

export type WithInertRouterProps = {
  history: History<unknown>;
};

/**
 * Wraps a `Component` and adds in the `history` API prop from `react-router` without making the
 * component render on any state change to the URL.
 *
 * Should be used on components which need pop/push functions but do not depend on `location` in
 * their render method.
 */
function withInertRouter<ComponentProps>(Component: React.ComponentType<ComponentProps & WithInertRouterProps>) {
  function WrapperInertRouter(inertProps: ComponentProps) {
    const history = useHistory();

    return <Component {...inertProps} history={history} />;
  }

  WrapperInertRouter.wrappedComponent = Component;
  WrapperInertRouter.displayName = `WrapperInertRouter(${Component.displayName || 'Unknown'})`;

  return WrapperInertRouter;
}

export { withInertRouter };
